import { URLList } from "@/data/url_list";
import { FetchApiClientMethod } from "@sadtx/fetch-api-client";
import { errorConverter, SATError, SATResult } from "@sadtx/sat-error";
import { PatientResponseDto } from "../dto/patient-reponse-dto";
import { UpdatePatientInfoRequestPayload } from "../payload/patient/update-paitent-info-request-payload";

export class PatientSource {
  constructor(private readonly client: FetchApiClientMethod) {}

  async fetchPatientList(): Promise<SATResult<PatientResponseDto[], SATError>> {
    try {
      const url = URLList.PATIENT.LIST;
      const response = await this.client.get(url);
      console.log("[PatientSource] :: fetchPatientList :: 환자 목록 조회 성공", response.data);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error("[PatientSource] :: fetchPatientList :: 환자 목록 조회 실패", error);
      const satError = errorConverter.convertError(error);
      return SATResult.failure(satError);
    }
  }

  async fetchPatient(patientUuid: string): Promise<SATResult<PatientResponseDto, SATError>> {
    try {
      const url = `${URLList.PATIENT.DETAIL}/${patientUuid}`;
      const response = await this.client.get(url);
      return SATResult.success(response.data);
    } catch (error: unknown) {
      console.error("[PatientSource] :: fetchPatientDetail :: 환자 상세 조회 실패", error);
      const satError = errorConverter.convertError(error);
      return SATResult.failure(satError);
    }
  }

  async updatePatientInfo(
    payload: UpdatePatientInfoRequestPayload
  ): Promise<SATResult<void, SATError>> {
    try {
      const url = `${URLList.PATIENT.DETAIL}/${payload.patientUuid}`;
      console.log("[PatientSource] :: updatePatientInfo :: url", url);
      console.log("[PatientSource] :: updatePatientInfo :: payload", payload);
      await this.client.put(url, payload.payload);
      return SATResult.success(void 0);
    } catch (error: unknown) {
      console.error("[PatientSource] :: updatePatientInfo :: 환자 상세 수정 실패", error);
      const satError = errorConverter.convertError(error);
      return SATResult.failure(satError);
    }
  }

  async activatePatient(patientUuid: string): Promise<SATResult<void, SATError>> {
    try {
      const url = `${URLList.PATIENT.ACTIVATE}/${patientUuid}`;
      await this.client.put(url);
      return SATResult.success(void 0);
    } catch (error: unknown) {
      console.error("[PatientSource] :: activatePatient :: 환자 계정 활성화 실패", error);
      const satError = errorConverter.convertError(error);
      return SATResult.failure(satError);
    }
  }

  async deactivatePatient(patientUuid: string): Promise<SATResult<void, SATError>> {
    try {
      const url = `${URLList.PATIENT.DEACTIVATE}/${patientUuid}`;
      await this.client.put(url);
      return SATResult.success(void 0);
    } catch (error: unknown) {
      console.error("[PatientSource] :: deactivatePatient :: 환자 계정 비활성화 실패", error);
      const satError = errorConverter.convertError(error);
      return SATResult.failure(satError);
    }
  }
}
